import React from 'react';
import { Heading } from '../../../../components';
import { sampleTasks } from '../../../../constants';
import { FaCheckCircle } from 'react-icons/fa';
import './CareerTasks.css';

const CareerTasks = () => {
    return (
        <section className='career-tasks-section'>
            <Heading title={'Co możesz robić?'} subTitle={'Przykładowe zadania'} />

            <div className='tasks-wrapper'>
                <p className='tasks-intro'>
                    W zależności od Twoich zainteresowań i predyspozycji, możesz zaangażować się w różnorodne działania. Oto przykłady tego, co robimy na co dzień:
                </p>

                <div className='tasks-grid'>
                    {sampleTasks.map((task, index) => (
                        <div className='task-item' key={index}>
                            <div className='task-icon'>
                                <FaCheckCircle />
                            </div>
                            <span>{task}</span>
                        </div>
                    ))}
                </div>

                <p className='tasks-outro'>
                    Zawsze dopasowujemy zadania do tego, czego chcesz się nauczyć.
                </p>
            </div>
        </section>
    );
};

export default CareerTasks;